import { Component } from 'react';
import { connect } from 'react-redux';
import { MemberLogin } from "@b/listing/components/MemberLogin";
import InventoryHeaderContainer from "@v/ticket-picker/containers/InventoryHeaderContainer";

class MemberLoginContainer extends Component {

  render() {
    return (
      <>
        <dialog className="tickets--as-overlay tickets-wrap" aria-modal="true" tabIndex="-1">
          <div className="tickets">
            <InventoryHeaderContainer />
            <MemberLogin onLogin={ this.props?.onLogin } isOverlay />
          </div>
        </dialog>
      </>
    )
  }
}


const mapStateToProps = (state) => ({
  isMembershipSkipped: !!state.ui?.skipMembership,
});


export default connect(mapStateToProps, null)(MemberLoginContainer)
